import * as React from 'react';

function SvgDelete(props) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.217 13.337a1.32 1.32 0 01-.1-.1c.036.036.067.071.1.1zm-.14-.06c-.034-.032-.068-.064-.1-.1.032.036.066.068.1.1zm11.271-10.76a.545.545 0 00-.38-.154h-2.67v-.837C10.298.96 9.84.5 9.278.5H4.721C4.158.5 3.7.96 3.7 1.526v.837H1.018a.52.52 0 00-.518.521c0 .288.231.521.518.521h.457v9.069c0 .566.457 1.026 1.02 1.026h9.155c.563 0 1.02-.46 1.02-1.026V3.405h.298a.532.532 0 00.532-.521.516.516 0 00-.152-.367zM4.72 1.53h4.555v.843H4.719V1.53zm6.93 10.943H2.495V3.405h9.154v9.067zm-4.656-7.32a.522.522 0 00-.52.524v4.86c0 .29.232.525.52.525.288 0 .52-.235.52-.524V5.676a.522.522 0 00-.52-.524zm-2.82 0a.522.522 0 00-.521.524v4.86c0 .29.233.525.52.525a.523.523 0 00.521-.524V5.676a.522.522 0 00-.52-.524zm5.611 0a.522.522 0 00-.52.524v4.86c0 .29.232.525.52.525a.523.523 0 00.521-.524V5.676a.522.522 0 00-.52-.524z"
        fill="#F5222D"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgDelete;
